import React from "react";
import SocialContact from "../../common/social-contact/index";
import intoimg from "../../../assets/introfoto.png";

function About() {
  return (
    <div className="pb-12">
      <div className="flex flex-col md:flex-row justify-between items-center mb-9">
        <div className="w-full md:w-2/3 mb-5 md:mb-0">
          <h1 className=" text-5xl font-semibold mb-0 pb-0">Christopher Eneze</h1>
          
          <p className="text-2xl text-blue-500 my-3">Full Stack Programmer,</p>
          <p className="mr-0 md:mr-5">I am knowledgeable, performance-driven, and detail-oriented individual who excels at configuring and maintaining hardware and software, developing automation scripts, analyzing data and resolving any technical support requests. Possess great technological expertise, well-developed communication skills, and important ability to perform well in a team</p>
          <div className="flex flex-col md:flex-row m-4">
            <a href="https://wa.me/+2348061537193" className="bg-pink-800 p-3 m-2 text-white font-semibold text-center" target="_blank" rel="noreferrer">Hire me</a>
            <a href="https://drive.google.com/file/d/1biNNDUpyzhTsuX3CJvwD6KfsOabQsBh4/view?usp=share_link" className="bg-orange-500 p-3 m-2 text-white font-semibold text-center" target="_blank" rel="noreferrer">Download Resume</a>
          </div>
        </div>
        <div className="w-full md:w-1/3 mb-5 md:mb-0">
          <img 
            src={intoimg}
            className=" h-[350px] shadow-md" alt="Christopher Eneze"
          />
        </div>
      </div>
      <SocialContact />
    </div>
  );
}

export default About;